import { TOGGLE_SNACKBAR } from './../events';

function data() {
	return {
		params: {
			customerId: null,
			page: 1,
			limit: 20,
			search: null,
		},
		table: {
			lastPage: 1,
			rows: [],
		},
		snackbar: {
			text: '',
			isVisible: false,
			color: 'primary',
			timeout: 0,
		},
	};
}

function goTo(name, options) {
	this.$router.push({ name, ...options });
}

async function loadData(url) {
	const { data: records, headers } = await this.$http.get(url, { params: this.params });
	this.table.lastPage = Number(headers['x-last-page']);
	this.table.rows = records.map((record) => {
		const newRecord = { ...record };
		newRecord.isSelected = false;
		return newRecord;
	});
	return { records, headers };
}

function onSearch(value, url) {
	this.params.search = value || null;
	this.params.page = 1;
	this.loadData(url);
}

function replaceString(word, selectionStart, newWord) {
	if (word) {
		return word.slice(0, selectionStart) + newWord + word.slice(selectionStart + 0);
	}
	return newWord;
}

function showNotification(text, color = 'green', timeout = 5000) {
	this.$bus.$emit(TOGGLE_SNACKBAR, { color, text, timeout });
}

function showGenericError(text = 'Ups, ocurrió algún problema') {
	this.showNotification(text, 'error');
}

function showRow(columns, columnId) {
	const column = columns.find(h => h.id === columnId);
	return column.visible;
}

function stopClick() {
	return false;
}

function onToggleSnackBar() {
	this.$bus.$on(TOGGLE_SNACKBAR, (snackbar) => {
		const newSnackbar = Object.assign({}, snackbar);
		newSnackbar.isVisible = true;
		this.snackbar = newSnackbar;
	});
}

function isPeru() {
	return process.env.COUNTRY === 'PER';
}

function goToHome() {
	this.goTo('page-home');
}

const mixin = {
	data,
	computed: {
		isPeru,
	},
	methods: {
		goTo,
		loadData,
		onSearch,
		replaceString,
		showGenericError,
		showNotification,
		showRow,
		stopClick,
		onToggleSnackBar,
		goToHome,
	},
};

export default mixin;



// WEBPACK FOOTER //
// ./src/mixins/global.js